/* Coria · functii noi: configurator kit, urmarire colet GLS, butoane cautare nuanta.
   Fiecare functie are setare de pornit/oprit in tema; aici doar logica din pagina. */
(function () {
  'use strict';
  if (window.__cfFeatures) return;
  window.__cfFeatures = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (!fmt) return v + ' lei';
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, v).replace(/\s+/g, ' ').trim();
  }

  /* ---------- Configurator kit ---------- */
  function kitInit(kit) {
    if (kit.__cfKit) return;
    kit.__cfKit = true;
    var fmt = '';
    try { fmt = JSON.parse(kit.querySelector('[data-cf-kit-money]').textContent); } catch (e) {}
    var btn = kit.querySelector('[data-cf-kit-add]');
    var msg = kit.querySelector('[data-cf-kit-msg]');
    var min = +kit.getAttribute('data-min') || 1;
    function checks() { return [].slice.call(kit.querySelectorAll('.cf-kit__check:checked:not(:disabled)')); }
    function update() {
      var c = checks(), sum = c.reduce(function (n, i) { return n + (+i.getAttribute('data-price') || 0); }, 0);
      kit.querySelector('[data-cf-kit-count]').textContent = c.length + (c.length === 1 ? ' produs' : ' produse');
      kit.querySelector('[data-cf-kit-total]').textContent = money(sum, fmt);
      btn.disabled = c.length < min;
      if (msg) msg.textContent = c.length < min ? 'Alege cel putin ' + min + ' produse.' : (kit.__cfMsg || '');
      var deal = kit.querySelector('[data-cf-kit-deal]');
      if (deal && window.CFKit && CFKit.active() && (window.CF_BUDDY || {}).kitBuilder !== false) {
        var k = CFKit.check(c.map(function (i) { return { type: i.getAttribute('data-type'), title: i.getAttribute('data-title'), quantity: 1 }; }));
        kit.__cfKitOk = k.ok;
        deal.hidden = false; deal.classList.toggle('is-ok', k.ok);
        deal.innerHTML = '<span class="cf-kit-deal__tag">' + CFKit.deal() + '</span><span>' + (k.ok ? CFKit.doneText() : CFKit.text() + ' ' + CFKit.missingText(k)) + '</span>';
      } else if (deal) { deal.hidden = true; kit.__cfKitOk = false; }
    }
    kit.addEventListener('change', function () { kit.__cfMsg = ''; update(); });
    btn.addEventListener('click', function () {
      var items = checks().map(function (i) { return { id: +i.value, quantity: 1 }; });
      if (!items.length) return;
      btn.disabled = true; btn.classList.add('is-busy');
      var cart = document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.section; });
        body.sections_url = location.pathname;
      }
      var code = kit.getAttribute('data-code');
      var KBc = window.CF_BUDDY || {};
      if (!code && kit.__cfKitOk && KBc.kitApply === 'code' && KBc.kitCode) code = KBc.kitCode;
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) { if (msg) msg.textContent = res.json.description || 'Nu am putut adauga kitul.'; return; }
          var after = code && code === KBc.kitCode && window.CFKit ? CFKit.apply() : code ? fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
          return after.then(function () {
            kit.__cfMsg = kit.__cfKitOk && window.CFKit ? 'Kitul a fost adaugat in cos. ' + CFKit.doneText() : 'Kitul a fost adaugat in cos.';
            if (msg) msg.textContent = kit.__cfKitOk && window.CFKit ? 'Kitul a fost adaugat in cos. ' + CFKit.doneText() : 'Kitul a fost adaugat in cos.';
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.json, source: 'cf-kit' } }));
            var useDrawer = !(window.CF_FEATURES && CF_FEATURES.kitDrawer === false);
            if (useDrawer && cart && typeof cart.renderContents === 'function' && res.json.sections) {
              try { cart.renderContents(res.json); if (typeof cart.open === 'function' && !cart.classList.contains('show')) cart.open(); return; } catch (e) {}
            }
            location.href = root + 'cart';
          });
        })
        .catch(function () { if (msg) msg.textContent = 'Conexiune intrerupta. Incearca din nou.'; })
        .finally(function () { btn.classList.remove('is-busy'); update(); });
    });
    update();
  }

  /* ---------- Urmarire colet GLS ---------- */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.matches || !f.matches('form[data-cf-track]')) return;
    ev.preventDefault();
    var awb = (f.elements.awb.value || '').replace(/\s+/g, '');
    if (!awb) return;
    window.open((f.getAttribute('data-url') || 'https://gls-group.com/RO/ro/urmarire-colet?match=') + encodeURIComponent(awb), '_blank', 'noopener');
  });

  /* ---------- Cautare nuanta (asistentul 3D) ---------- */
  document.addEventListener('click', function (ev) {
    var s = ev.target.closest('[data-cf-colorsearch], [data-cf-similar]');
    if (!s) return;
    var api = window.CoriaBuddySmart;
    if (!api || typeof api.colorSearch !== 'function') {
      s.classList.add('is-wait');
      setTimeout(function () { s.classList.remove('is-wait'); }, 1500);
      return;
    }
    ev.preventDefault();
    var drawer = s.closest('search-drawer, .search-drawer, [data-search-drawer], details[open]');
    if (drawer) { var x = drawer.querySelector('[data-drawer-close], .drawer-close, [data-popup-close]'); if (x) x.click(); }
    var h = s.getAttribute('data-cf-similar');
    if (h && typeof api.similar === 'function') api.similar(h); else api.colorSearch();
  });

  var F = window.CF_FEATURES || {};

  /* ---------- Eticheta Nou: dispare singura cand trec zilele (chiar si pe pagini din cache) ---------- */
  function expireNew() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-cf-new-until]').forEach(function (b) { if (+b.getAttribute('data-cf-new-until') < now) b.remove(); });
  }
  expireNew();
  setInterval(expireNew, 60000);
  document.addEventListener('shopify:section:load', expireNew);
  document.addEventListener('cart:item-added', expireNew);

  /* ---------- Trimite cosul (link care reface acelasi cos) ---------- */
  function shareBtn() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cf-share-cart'; b.setAttribute('data-cf-share-cart', '');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5.5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="18.5" r="2.5"/><path d="m8.2 10.9 7.6-4.2M8.2 13.1l7.6 4.2"/></svg><span>Trimite cosul</span>';
    return b;
  }
  function placeShare() {
    if (F.shareCart === false) return;
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var host = btn.parentElement;
      if (!host || btn.closest('.cb-bubble,.cbs-actions,.cbs-holo,#coria-box')) return;
      var box = host.parentElement || host;
      if (box.querySelector('[data-cf-share-cart]')) return;
      box.appendChild(shareBtn());
    });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-cf-share-cart]');
    if (!b) return;
    ev.preventDefault();
    var label = b.querySelector('span');
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) { label.textContent = 'Cosul este gol'; return; }
      var url = location.origin + root + 'cart/' + c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') + '?storefront=true';
      var done = function (t) { label.textContent = t; setTimeout(function () { label.textContent = 'Trimite cosul'; }, 2600); };
      if (navigator.share) {
        navigator.share({ title: 'Cosul meu Coria', text: c.item_count + ' produse Coria', url: url }).then(function () { done('Trimis!'); }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { done('Link copiat!'); }, function () { window.prompt('Copiaza linkul cosului:', url); });
      } else { window.prompt('Copiaza linkul cosului:', url); }
    }).catch(function () { label.textContent = 'Incearca din nou'; });
  });

  /* ---------- Vibratie scurta la adaugarea in cos (telefon) ---------- */
  function buzz() { if (F.haptics !== false && navigator.vibrate && matchMedia('(pointer: coarse)').matches) { try { navigator.vibrate(18); } catch (e) {} } }
  document.addEventListener('cart:item-added', buzz);
  document.addEventListener('click', function (ev) { if (ev.target.closest('button[name="add"], .cf-trend-atc__btn, .cf-gal__add button, [data-cf-kit-add]')) buzz(); }, true);

  /* ---------- Tasta / deschide cautarea ---------- */
  document.addEventListener('keydown', function (ev) {
    if (F.slashSearch === false || ev.key !== '/' || ev.ctrlKey || ev.metaKey || ev.altKey) return;
    var t = ev.target; if (t && (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName))) return;
    var s = document.querySelector('.header--icon-item.search .header--icon-link, .header--icon-item.search a, [data-source="search-drawer"]');
    if (s) { ev.preventDefault(); s.click(); }
  });



  /* ---------- 14. numere spuse in cuvinte -> cifre ("saptezeci si doi" -> 72) ---------- */
  var RO_U = { zero: 0, unu: 1, una: 1, un: 1, o: 1, doi: 2, doua: 2, trei: 3, patru: 4, cinci: 5, sase: 6, sapte: 7, opt: 8, noua: 9 };
  var RO_T = { zece: 10, unsprezece: 11, unsprezce: 11, doisprezece: 12, douasprezece: 12, treisprezece: 13, paisprezece: 14, patrusprezece: 14, cincisprezece: 15, saisprezece: 16, sasesprezece: 16, saptesprezece: 17, optsprezece: 18, nouasprezece: 19 };
  var RO_Z = { douazeci: 20, treizeci: 30, patruzeci: 40, cincizeci: 50, saizeci: 60, saptezeci: 70, optzeci: 80, nouazeci: 90 };
  function roNumbers(text) {
    var words = String(text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().split(/\s+/);
    var out = [], num = null, last = '';
    function flush() { if (num !== null) { out.push(String(num)); num = null; } }
    for (var i = 0; i < words.length; i++) {
      var w = words[i].replace(/[^a-z0-9]/g, '');
      if (w === 'si' && num !== null && num % 10 === 0 && num >= 20 && num % 100 !== 0) { last = w; continue; }
      if (RO_Z[w] !== undefined) { num = (num !== null && num >= 100 ? num : 0) + RO_Z[w]; last = w; continue; }
      if (RO_T[w] !== undefined) { num = (num !== null && num >= 100 ? num : 0) + RO_T[w]; last = w; continue; }
      if ((w === 'suta' || w === 'sute') ) { num = (num !== null && num < 10 ? num : 1) * 100; last = w; continue; }
      var nextW = (words[i + 1] || '').replace(/[^a-z]/g, '');
      if (RO_U[w] !== undefined && !((w === 'o' || w === 'un' || w === 'una') && nextW !== 'suta' && nextW !== 'sute')) {
        if (w === 'zero' && num === null) { out.push('0'); last = w; continue; }
        if (num !== null && (num % 10 === 0) && (last === 'si' || num >= 100)) { num += RO_U[w]; last = w; continue; }
        flush(); num = RO_U[w]; last = w; continue;
      }
      flush(); out.push(words[i]); last = w;
    }
    flush();
    return out.join(' ').replace(/\b0 (\d)/g, '0$1').replace(/\b(0\d) (\d)\b/g, '$1$2');
  }
  window.CoriaRoNumbers = roNumbers;

  /* ---------- 10 / 11. pe cardurile din colectii: mostra de culoare si "+N nuante" ---------- */
  var cardData = null, cardLoading = null;
  function loadCardData() {
    if (cardData) return Promise.resolve(cardData);
    if (!cardLoading) cardLoading = fetch(F.cardExtras).then(function (r) { return r.json(); }).then(function (j) { cardData = j.h || {}; return cardData; }).catch(function () { cardLoading = null; return {}; });
    return cardLoading;
  }
  function decorateCards(root2) {
    if (!F.cardExtras || (F.cardSwatch === false && F.cardCount === false)) return;
    var cards = (root2 || document).querySelectorAll('.product--card:not([data-cf-card])');
    if (!cards.length) return;
    loadCardData().then(function (d) {
      /* faza 1: pregatim totul fara sa atingem pagina; faza 2: o singura citire de stil pe lot; faza 3: doar scrieri -> fara layout fortat repetat */
      var jobs = [];
      cards.forEach(function (card) {
        if (card.hasAttribute('data-cf-card')) return;
        var hEl = card.querySelector('[data-handle]'); var h = hEl && hEl.getAttribute('data-handle');
        if (!h) { var a = card.querySelector('a[href*="/products/"]'); var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href')); h = m && m[1]; }
        var row = h && d[h];
        if (!row) { jobs.push({ card: card }); return; }
        var media = card.querySelector('.product--card-media, .product--media, .media') || card;
        var wrap = document.createElement('div'); wrap.className = 'cf-card-meta';
        if (F.cardSwatch !== false && row[0]) { var sw = document.createElement('i'); sw.className = 'cf-card-sw'; sw.style.setProperty('--sw', row[0]); sw.title = 'Culoarea nuantei'; wrap.append(sw); }
        if (F.cardCount !== false && row[1] > 2) { var c = document.createElement('span'); c.className = 'cf-card-count'; var nk = row[2] === 'a' ? ['aroma', 'arome'] : row[2] === 'm' ? ['model', 'modele'] : ['nuanta', 'nuante']; c.textContent = '+' + (row[1] - 1) + ' ' + (row[1] - 1 === 1 ? nk[0] : nk[1]); wrap.append(c); }
        jobs.push({ card: card, media: media, wrap: wrap.childElementCount ? wrap : null });
      });
      jobs.forEach(function (j) { if (j.wrap) j.stat = getComputedStyle(j.media).position === 'static'; });
      jobs.forEach(function (j) {
        j.card.setAttribute('data-cf-card', '');
        if (!j.wrap) return;
        if (j.stat) j.media.style.position = 'relative';
        j.media.append(j.wrap);
      });
    });
  }
  function cardsIdle() { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(function () { decorateCards(); }); }
  if (document.readyState === 'complete') cardsIdle(); else window.addEventListener('load', cardsIdle);
  var cardRaf = 0;
  new MutationObserver(function (ms) {
    if (cardRaf) return;
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('.product--card') || n.querySelector('.product--card'))) { cardRaf = requestAnimationFrame(function () { cardRaf = 0; decorateCards(); }); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });


  /* ---------- Derulare laterala peste tot pe site: rotita mouse-ului + tragere cu mouse-ul (pe telefon merge cu degetul) ---------- */
  function hScroller(start) {
    for (var n = start; n && n !== document.body && n.nodeType === 1; n = n.parentElement) {
      if (n.closest && n.closest('.swiper, swiper-slider, .swiper-container, dialog .cf-vshort-dlg')) return null;
      if (n.scrollWidth > n.clientWidth + 2) {
        var ox = getComputedStyle(n).overflowX;
        if (ox === 'auto' || ox === 'scroll') return n;
      }
    }
    return null;
  }
  if (F.hScroll !== false) {
    document.addEventListener('wheel', function (ev) {
      if (ev.ctrlKey || Math.abs(ev.deltaX) > Math.abs(ev.deltaY)) return; // trackpad lateral sau zoom: lasa browserul
      var el = hScroller(ev.target); if (!el) return;
      var max = el.scrollWidth - el.clientWidth;
      if ((ev.deltaY > 0 && el.scrollLeft >= max - 1) || (ev.deltaY < 0 && el.scrollLeft <= 0)) return; // la capat: deruleaza pagina
      ev.preventDefault();
      el.scrollLeft += ev.deltaY * (ev.deltaMode === 1 ? 32 : 1);
    }, { passive: false });

    var drag = null;
    document.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
      if (ev.target.closest('input, textarea, select, [contenteditable]')) return;
      var el = hScroller(ev.target); if (!el) return;
      drag = { el: el, x: ev.clientX, left: el.scrollLeft, moved: false };
    });
    document.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      var dx = ev.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      drag.moved = true; drag.el.classList.add('cf-dragging');
      drag.el.scrollLeft = drag.left - dx;
    });
    var endDrag = function () {
      if (!drag) return;
      var d = drag; drag = null; d.el.classList.remove('cf-dragging');
      if (d.moved) { var stop = function (e) { e.preventDefault(); e.stopImmediatePropagation(); }; document.addEventListener('click', stop, { capture: true, once: true }); setTimeout(function () { document.removeEventListener('click', stop, true); }, 50); }
    };
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  }


  /* ---------- Sageti pentru randurile laterale (desktop) + elementul ales adus in vedere ---------- */
  var NAV_SEL = '.coria-collection-list, coria-product-choices .cfc-chips, .cf-fy__track, .cf-gal__track, .cf-kit__grid, .cc-empty-actions, #coria-chips';
  function navFor(el) {
    if (F.hScroll === false || el.__cfNav) return;
    if (el.scrollWidth <= el.clientWidth + 4) return;
    el.__cfNav = true;
    var nav = document.createElement('div'); nav.className = 'cf-hnav'; nav.setAttribute('aria-hidden', 'true');
    var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6l6 6-6 6"/></svg>';
    nav.innerHTML = '<button type="button" tabindex="-1" data-d="-1" class="cf-hnav__prev">' + CHEV + '</button><button type="button" tabindex="-1" data-d="1" class="cf-hnav__next">' + CHEV + '</button>';
    el.parentNode.insertBefore(nav, el);
    var prev = nav.children[0], next = nav.children[1];
    function upd() { var max = el.scrollWidth - el.clientWidth; prev.disabled = el.scrollLeft <= 2; next.disabled = el.scrollLeft >= max - 2; nav.hidden = max <= 4; }
    nav.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; el.scrollBy({ left: +b.dataset.d * Math.max(160, el.clientWidth * .7), behavior: 'smooth' }); });
    el.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    var cur = el.querySelector('.is-current, [aria-pressed="true"]');
    if (cur && cur.offsetLeft > el.clientWidth - 40) el.scrollLeft = cur.offsetLeft - 24;
    setTimeout(upd, 60);
  }
  function scanNav() { document.querySelectorAll(NAV_SEL).forEach(navFor); }
  var navRaf = 0;
  new MutationObserver(function (ms) {
    if (navRaf || F.hScroll === false) return;
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches(NAV_SEL) || n.querySelector(NAV_SEL) || (n.parentElement && n.parentElement.matches(NAV_SEL)))) {
        navRaf = requestAnimationFrame(function () { navRaf = 0; scanNav(); }); return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', function () { setTimeout(scanNav, 400); });

  /* ---------- Cautare vocala (microfon in campurile de cautare) ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7"/></svg>';
  function addMic(input) {
    if (!SR || F.voiceSearch === false || !input || input.__cfMic) return;
    input.__cfMic = true;
    var host = input.parentElement; if (!host) return;
    // campul nu are un invelis propriu (ex. cautarea din selector): ii fac unul, ca microfonul sa stea in camp
    if ([].filter.call(host.children, function (c) { return c !== input && c.tagName !== 'LABEL' && !c.matches('button, [type="submit"], svg'); }).length) {
      var wrap = document.createElement('span'); wrap.className = 'cf-mic-wrap';
      input.parentNode.insertBefore(wrap, input); wrap.append(input); host = wrap;
    }
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cf-mic'; b.innerHTML = MIC;
    b.setAttribute('aria-label', 'Cauta cu vocea');
    host.append(b);
    input.classList.add('cf-has-mic');
    b.addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      if (b.classList.contains('is-on')) { try { b.__rec && b.__rec.stop(); } catch (e) {} return; }
      var rec = new SR(); b.__rec = rec;
      rec.lang = 'ro-RO'; rec.interimResults = true; rec.maxAlternatives = 1;
      var old = input.placeholder;
      rec.onstart = function () { b.classList.add('is-on'); input.placeholder = 'Te ascult... spune ce cauti'; };
      rec.onresult = function (e) {
        var t = ''; for (var i = 0; i < e.results.length; i++) t += e.results[i][0].transcript;
        input.value = roNumbers(t.replace(/[.!?]+$/, '')).trim();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        if (e.results[e.results.length - 1].isFinal) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
          var form = input.form;
          if (form && /search/.test(form.getAttribute('action') || '') && !input.closest('search-drawer, .search-drawer, [data-search-drawer], .predictive-search')) form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      };
      rec.onerror = function (e) { input.placeholder = e.error === 'not-allowed' ? 'Permite accesul la microfon din browser' : 'Nu am auzit bine. Mai incearca.'; setTimeout(function () { input.placeholder = old; }, 2600); };
      rec.onend = function () { b.classList.remove('is-on'); if (/Te ascult/.test(input.placeholder)) input.placeholder = old; input.focus(); };
      try { rec.start(); } catch (e) {}
    });
  }
  function scanMics() {
    document.querySelectorAll('input[type="search"], input[name="q"], .coria-choice-search').forEach(addMic);
  }
  var micRaf = 0;
  new MutationObserver(function (ms) {
    if (micRaf || !SR || F.voiceSearch === false) return;
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('input[type="search"], input[name="q"]') || n.querySelector('input[type="search"], input[name="q"]'))) {
        micRaf = requestAnimationFrame(function () { micRaf = 0; scanMics(); }); return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Video scurt de aplicare ---------- */
  function vshortInit() {
    document.querySelectorAll('[data-cf-vshort]').forEach(function (box) {
      if (box.__cfV) return; box.__cfV = true;
      var v = box.querySelector('video');
      v.addEventListener('playing', function () { box.classList.add('is-playing'); });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
      if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) { if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: .4 }).observe(v);
      }
      box.querySelector('[data-cf-vshort-open]').addEventListener('click', function () {
        var d = document.getElementById('cf-vshort-dlg');
        if (!d) {
          d = document.createElement('dialog'); d.id = 'cf-vshort-dlg'; d.className = 'cf-vshort-dlg';
          d.innerHTML = '<button type="button" class="cf-wel__x" aria-label="Inchide">&times;</button><video controls playsinline autoplay muted loop></video>';
          document.body.append(d);
          d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('.cf-wel__x')) { d.querySelector('video').pause(); d.close(); } });
        }
        var big = d.querySelector('video'); big.src = v.currentSrc || v.src; big.poster = v.poster || '';
        d.showModal(); var p = big.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }
  // la schimbarea produsului din selector: video-ul produsului nou, daca are
  document.addEventListener('coria:product-switched', function (ev) {
    var box = document.querySelector('[data-cf-vshort]'); var h = ev.detail && ev.detail.handle;
    if (!box || !h) return;
    fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var m = (p.media || []).filter(function (x) { return x.media_type === 'video'; })[0];
      if (!m) return;
      var src = (m.sources || []).filter(function (s) { return s.format === 'mp4'; }).sort(function (a, b) { return a.height - b.height; })[0];
      if (!src) return;
      var v = box.querySelector('video'); v.src = src.url; if (m.preview_image) v.poster = m.preview_image.src + (m.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
      var pl = v.play(); if (pl && pl.catch) pl.catch(function () {});
    }).catch(function () {});
  });


  /* ---------- Kit cu reducere (setari in tema: "Coria · Kit cu reducere", OPRIT implicit) ----------
     window.CFKit e folosit si de robot: CFKit.active(), CFKit.check(items), CFKit.text(), CFKit.apply(). */
  var KB = window.CF_BUDDY || {};
  var KIT_LABEL = { base: 'baza', color: 'culoare', top: 'top coat', cleaner: 'cleaner' };
  function kitRole(type, title) {
    var t = String(type || '').toLowerCase(), n = String(title || '').toLowerCase();
    var isBase = /\bbaz[aă]\b|\bbase\b/.test(n);
    if (t === 'top coat' || (/\btop\b/.test(n) && !isBase)) return 'top';
    if (t === 'rubber base' || isBase) return 'base';
    if (t === 'cleaner' || /\bcleaner\b/.test(n)) return 'cleaner';
    if (t === 'oja semipermanenta' || t === 'gel color' || /\boja\b|\bgel\s+color\b/.test(n)) return 'color';
    return '';
  }
  function kitNeeds() {
    if (KB.kitCombo === 'any') return [];
    return KB.kitCombo === 'base_color_top_cleaner' ? ['base', 'color', 'top', 'cleaner'] : ['base', 'color', 'top'];
  }
  function kitActive() {
    if (!KB.kitOn || !(+KB.kitValue > 0)) return false;
    var now = Date.now(), s = Date.parse(KB.kitStart || ''), e = Date.parse((KB.kitEnd || '') + 'T23:59:59');
    if (s && now < s) return false;
    if (KB.kitEnd && e && now > e) return false;
    if (KB.kitApply !== 'auto' && !KB.kitCode) return false;
    return true;
  }
  function kitDeal() { return KB.kitType === 'fixed' ? '-' + (+KB.kitValue) + ' lei' : '-' + (+KB.kitValue) + '%'; }
  function kitText() {
    if (KB.kitMsg) return String(KB.kitMsg).replace(/\[reducere\]/g, kitDeal());
    var n = kitNeeds();
    return 'Kit complet: ' + kitDeal() + (n.length ? ' la ' + n.map(function (r) { return KIT_LABEL[r]; }).join(' + ') : ' la minim ' + (KB.kitMin || 3) + ' produse') + '.';
  }
  /* items: [{type, title, quantity}] -> {ok, missing:[rol], need: cate produse mai lipsesc} */
  function kitCheck(items) {
    var have = {}, count = 0;
    (items || []).forEach(function (i) { var q = +i.quantity || 1; count += q; var r = kitRole(i.type, i.title); if (r) have[r] = true; });
    var missing = kitNeeds().filter(function (r) { return !have[r]; });
    var need = Math.max(0, (+KB.kitMin || 0) - count);
    return { ok: !missing.length && !need, missing: missing, need: need };
  }
  function kitMissingText(c) {
    var parts = c.missing.map(function (r) { return KIT_LABEL[r]; });
    if (c.need && !parts.length) parts.push(c.need + (c.need === 1 ? ' produs' : ' produse'));
    return 'Mai adauga ' + parts.join(', ').replace(/, ([^,]*)$/, ' si $1') + ' si primesti ' + kitDeal() + '.';
  }
  function kitApply() {
    if (KB.kitApply !== 'code' || !KB.kitCode) return Promise.resolve(false);
    try { sessionStorage.setItem('cfKitCode', KB.kitCode); } catch (e) {}
    return fetch(root + 'discount/' + encodeURIComponent(KB.kitCode) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .then(function () { return true; }).catch(function () { try { sessionStorage.removeItem('cfKitCode'); } catch (e) {} return false; });
  }
  function kitDoneText() {
    if (KB.kitApply === 'code') return 'Kit complet! Reducerea ' + kitDeal() + ' (cod ' + KB.kitCode + ') se aplica la plata.';
    if (KB.kitApply === 'message') return 'Kit complet! Foloseste codul ' + KB.kitCode + ' la plata pentru ' + kitDeal() + '.';
    return 'Kit complet! Reducerea ' + kitDeal() + ' se aplica automat la plata.';
  }
  window.CFKit = { active: kitActive, role: kitRole, check: kitCheck, text: kitText, deal: kitDeal, apply: kitApply, missingText: kitMissingText, doneText: kitDoneText };

  /* Nota din cos (sertar si pagina /cart) */
  var kitBusy = 0;
  function kitCart() {
    if (!document.querySelector('[data-cf-kit-cart]') || !kitActive()) return;
    clearTimeout(kitBusy);
    kitBusy = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var items = (cart.items || []).map(function (i) { return { type: i.product_type, title: i.product_title, quantity: i.quantity }; });
        var c = kitCheck(items), html = '';
        if (items.length && c.ok) {
          html = '<b>' + kitDoneText() + '</b>' + (KB.kitApply === 'message' ? ' <button type="button" class="cf-kit-cart__copy" data-cf-kit-copy>Copiaza codul</button>' : '');
          var done = ''; try { done = sessionStorage.getItem('cfKitCode'); } catch (e) {}
          if (KB.kitApply === 'code' && done !== KB.kitCode) kitApply();
        } else if (items.length) html = '<span>' + kitText() + '</span> <b>' + kitMissingText(c) + '</b>';
        document.querySelectorAll('[data-cf-kit-cart]').forEach(function (b) {
          b.innerHTML = html; b.hidden = !html; b.classList.toggle('is-ok', c.ok);
        });
      }).catch(function () {});
    }, 250);
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-cf-kit-copy]');
    if (!b || !KB.kitCode) return;
    var ok = function () { b.textContent = 'Cod copiat!'; };
    if (navigator.clipboard) navigator.clipboard.writeText(KB.kitCode).then(ok, function () { window.prompt('Codul tau:', KB.kitCode); });
    else window.prompt('Codul tau:', KB.kitCode);
  });
  ['cart:item-added', 'cart:updated', 'cart:refresh'].forEach(function (e) { document.addEventListener(e, kitCart); });
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('[data-cf-kit-cart]') || n.querySelector('[data-cf-kit-cart]'))) { kitCart(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function scan() { kitCart(); document.querySelectorAll('[data-cf-kit]').forEach(kitInit); placeShare(); scanMics(); vshortInit(); scanNav(); }
  var shareRaf = 0;
  new MutationObserver(function (ms) {
    if (shareRaf || F.shareCart === false) return;
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('button[name="checkout"]') || n.querySelector('button[name="checkout"]'))) {
        shareRaf = requestAnimationFrame(function () { shareRaf = 0; placeShare(); }); return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
